import { useEffect, useState } from "react";
import { navSections } from "@/mocks/home-data";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-all duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/85 backdrop-blur-md"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex max-w-[1280px] items-center justify-between gap-6 px-4 py-3.5 md:px-6">
        <a href="#top" className="flex items-center gap-2.5" aria-label="大雷网站首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg" />
          </span>
          <span className="font-heading text-lg font-black tracking-tight text-foreground-950 md:text-xl">
            大雷<span className="text-primary-600">网站</span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="主导航">
          {navSections.map((s) => (
            <a
              key={s.href}
              href={s.href}
              className="font-label text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {s.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 lg:flex">
          <a
            href="#baoliao"
            className="font-label whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            热雷榜
          </a>
          <a
            href="#dingyue"
            className="font-label whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅瓜报
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          aria-label="展开菜单"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navSections.map((s) => (
              <a
                key={s.href}
                href={s.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 font-label text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {s.label}
              </a>
            ))}
            <a
              href="#dingyue"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-md bg-primary-500 px-3 py-2.5 text-center font-label text-sm font-semibold text-background-50"
            >
              订阅瓜报
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}